exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup-box[data-v-4d3cb54e] {\n  width: 95%;\n  max-width: 800px;\n  height: 50vh;\n}\n.fullscreen-iframe[data-v-4d3cb54e] {\n  width: 100%;\n  height: 360px;\n  border-radius: 10px;\n}\n@media (max-width: 650px){\n.popup-box[data-v-4d3cb54e]{\n    width: 95%;\n    height: 100%;\n}\n.fullscreen-iframe[data-v-4d3cb54e] {\n    width: 100%;\n    height: 80vh;\n}\n}\n\n", ""]);

// exports
